<!-- 课程表 -->
<template>
    <div>
      <div class="course_Timetable">
        <el-row class="content_block mb30">
          <el-row class="title_head">
            <el-col :span="12">
              <span class="class_img">
                <el-image class="title_img" :src="kb_"></el-image>
              </span>
              <span>课程表</span>
            </el-col>
            <el-col :span="12" style="text-align: right;">
              <div class="block_time">
                <el-date-picker
                  v-model="onYear"
                  type="year"
                  placeholder="选择年">
                </el-date-picker>
              </div>
              <div class="block_time">
                <el-date-picker
                  v-model="onMonth"
                  type="month"
                  placeholder="选择年">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-calendar>
              <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
              <template
                slot="dateCell"
                slot-scope="{date, data}">
                <el-row :class="data.isSelected ? 'is-selected' : ''">
                  <el-col :span="8" style="text-align: center;border-right: 1px solid #E5E5E5;height: 70px;line-height: 70px;">
                    {{ data.day.split('-').slice(1).join('-') }}
                  </el-col>
                  <el-col :span="16" class="tc">
                    <template v-if="!$isEmpty(timeTableMap[data.day])">
                      <p class="m5 font13">{{timeTableMap[data.day][0].teacherOpenCourseScheduleSessionClassName}}</p>
                        <p class="m5 font12"  v-for="(item,index) in timeTableMap[data.day]">
                          {{item.teacherOpenCourseScheduleSessionTagName}} {{item.teacherOpenCourseScheduleSessionTagStartTime}} - {{item.teacherOpenCourseScheduleSessionTagEndTime}}
                        </p>
                      <!-- <p class="m5 font12">{{}}</p> -->
                    </template>
                    <template v-else>
                      <p class="m5 font12" style="line-height: 70px;">-</p>
                    </template>
<!--                    <p class="m5 font13">{{ Number(data.day.split('-').slice(-1)) % 3 == 0?'1':'2'}}号教学楼</p>
                    <p class="m5 font12">{{ Number(data.day.split('-').slice(-1)) % 3 == 0?'第一节、第二节':'第三节、第四节'}}</p>
                    <p class="m5 font12">{{ Number(data.day.split('-').slice(-1)) % 3 == 0?'李老师':'王老师'}}</p> -->
                  </el-col>
                </el-row>
              </template>
            </el-calendar>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>

export default {
  name: 'Timetable',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      kb_:require("../../../images/course/kb@2x_.png"),
      onYear:"",
      onMonth:"",
      timeTableMap:{} //存入相应时间课程信息{日期：{课程信息}}
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo(){ //获取数据
      let param = {
        teacherOpenCourseId:this.courseId
      }
      this.$get("/api/teacherOpenCourseMergeScheduleSession/getInfo.do",param).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data.teacherOpenCourseScheduleSession) && !this.$isEmpty(ret.data.teacherOpenCourseScheduleSession.sessionTagList)){
            for(let item of ret.data.teacherOpenCourseScheduleSession.sessionTagList){
              if(this.$isEmpty(this.timeTableMap[item.teacherOpenCourseScheduleSessionDayTime])){
                this.timeTableMap[item.teacherOpenCourseScheduleSessionDayTime] = [];
              }
              this.timeTableMap[item.teacherOpenCourseScheduleSessionDayTime].push(item);
            }
            this.timeTableMap = Object.assign({},this.timeTableMap);
          }
        }else{
          this.$message.error(ret.msg);
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Timetable{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
        height: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
      .el-calendar-table .el-calendar-day:hover{
        color: #409EFF;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/Timetable.vue